import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import styles from '../../styles/mobile.css';

import type { IWrapperDeps, IWrapperProps } from './models';
import { Wrapper as Component } from './wrapper';

export const WrapperMobile = createWidget<IWrapperDeps, IWrapperProps>({ styles })(Component);
